import { createDraftSafeSelector } from '@reduxjs/toolkit';

const auctionsWatchSelector = createDraftSafeSelector(
  (state: RootState) => state.auctionsWatch,
  (state) => {
    if (state.pending?.auctionId) {
      return {
        ...state.auctions,
        [state.pending.auctionId]: state.pending.watch,
      };
    }

    return state.auctions;
  },
);

export const internalSelectors = {
  auctionsWatchSelector,
};
